import { connect } from 'react-redux';
import ScoreCardAnalytic from './ScoreCardAnalytic';

const mapStateToProps = ({ search }) => ({
    navigating: search.navigating,
    navigatingTo: search.navigatingTo,
    navigationFailedFlag: search.navigationFailedFlag
});

export default connect(mapStateToProps)(ScoreCardAnalytic);
